import { Control, Controller, FieldValues, UseFormRegister } from "react-hook-form"


export interface CheckBoxProps {
  data: any
  onChange: () => void
  checkBoxStyle: string
  labelStyle: string
  name: string
  required?: boolean
  register: UseFormRegister<FieldValues>
  control: Control<any, any>
  defaultValue?: any
}
const Checkbox = ({ data, defaultValue, onChange, checkBoxStyle, labelStyle, name,
  required,
  register, control }: CheckBoxProps) => {
  return (
    <>
      <Controller
        key={defaultValue}
        defaultValue={defaultValue}
        name={name || 'checklist'}
        control={control}
        render={({ field }) => (
          <>
            {data.map(({ id, label,sys_id }, index) => {
              return (
                <div key={index}>
                  <input id={`${name}-${index}`}
                    {...register(name, { required: required })}
                    type="checkbox"
                    className={checkBoxStyle}
                    name={`${label}`}
                    value={sys_id}
                    checked={field.value?.includes(sys_id)}
                    onChange={(e) => {
                      onChange()
                      if (e.target.checked) {
                        const value = field.value === 'false' ? [e.target.value] : [...(field?.value ? field?.value : []), e.target.value]
                        field.onChange(value);
                      } else {
                        field.onChange(field.value.filter((item) => item !== e.target.value));
                      }
                    }}
                  />
                  <label
                    data-testid="test-checkbox-label"
                    htmlFor={`${name}-${index}`} className={labelStyle}>{label}</label>
                </div>
              );
            })}

          </>
        )}
      />

    </>
  )
};

export default Checkbox;